import {Props} from './types';
import {highlight} from './utils';


const View: React.FC<Props> = (props: Props) => {
  if (props.store.result === undefined) {
    return null;
  }
  const result = props.store.result;
  const title = result.title || '';
  const lines = result.text.split('\n').slice(1);

  return (
    <div ref={null} className='d-flex flex-column pb-10'>
      <div className='d-flex flex-column p-2 px-4'>
        <div className='d-flex flex-row justify-content-end'>
          <div className='px-1'>
            <button
              className='btn-plane-yellow'
              type="button"
              onClick={props.handlers.focus}
            >
                Zoom
            </button>
          </div>
          <div className='px-1'>
            <button
              className='btn btn-danger'
              onClick={props.handlers.close}
            >×</button>
          </div>
        </div>
        <h3 className='text-lg'>
          {highlight(title, 0, props.handlers.handleClickWord, 'text-pink-600', props.store.activeLocation)}
        </h3>
        <div className='d-flex flex-column'>
          {lines.map((line, key) => <span key={key}>{highlight(line, key, props.handlers.handleClickWord, 'text-pink-600', props.store.activeLocation)}</span>)}
        </div>
        <div className='d-flex flex-row'>
          <span className=''>
          solr score: {Math.floor((result.solrScore || NaN) * 1e2) / 1e2},
          distance[km]: {Math.floor((result.distance || NaN) * 1e2) / 1e2}
          </span>
        </div>
      </div>
    </div>
  );
};


export default View;
